import { Controller } from "@hotwired/stimulus"

// Shows only the selected protocol's fieldset(s). Degrades gracefully: without JS both are visible.
export default class extends Controller {
  static targets = ["select", "saml", "oidc"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasSelectTarget) return
    const protocol = this.selectTarget.value
    this.samlTargets.forEach((el) => (el.hidden = protocol !== "saml"))
    this.oidcTargets.forEach((el) => (el.hidden = protocol !== "oidc"))
  }
}
